import { Box, Skeleton } from "@mui/material";

export default function LocationTreeRowsSkeleton({ count = 8 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          sx={{
            px: 1.5,
            py: 0.75,
            display: "flex",
            alignItems: "center",
            gap: 1,
            pl: 1.5 + (i % 3) * 1.5,
          }}
        >
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton variant="text" width={`${55 + (i % 4) * 8}%`} height={18} />
        </Box>
      ))}
    </>
  );
}
